import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ContactKeyEntityLinkContainerModel} from '../../../../../../models/aggregates/crm/contact-key';

@Injectable({providedIn: 'root'})
export class ContactKeyEntityLinkService extends BaseApiTemplateService<ContactKeyEntityLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'contact-key-entity-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'contact-key-entity-links';
    this.httpClient = http;
  }

}